import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import DataTable from '../DataTable';
import { toUtc } from '../../libs/date';
import moment from 'moment';

@inject('requestStore')
@observer
class RequestDetailObservationList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    requestStore: PropTypes.object.isRequired,
  }

  componentWillMount() { this.reset(); }

  @observable observations = [];

  slug = '/request';
  columns = [
    { key: 'raw_data_id', label: 'Raw Data ID' },
    { key: 'series_id', label: 'Series ID' },
    { key: 'timestamp', label: 'Timestamp' },
    { key: 'time', label: 'Time' },
    { key: 'value', label: 'Value' },
    { key: 'stage', label: 'Stage' },
    { key: 'quality', label: 'Quality' },
    // { key: 'origin_data_id', label: 'Origin Data ID' },
  ];

  @action reset() {
    const { params: { id }, requestStore } = this.props;
    const request = requestStore.findById(id);
    const observations = (request && request.observation) || [];
    this.observations = observations.map((item, index) => {
      return Object.assign({}, item, {
        time: toUtc(item.time),
        timestamp: toUtc(item.timeStamp),
        id: index,
      });
    });
  }

  render() {
    return (
      <DataTable
        data={this.observations}
        slug={this.slug}
        columns={this.columns}
        readOnly
      />
    );
  }
}

export default RequestDetailObservationList;



// WEBPACK FOOTER //
// ./src/components/Request/RequestDetailObservationList.js